<article class="ticket-card" [class.new-ticket]="isNewTicket()" [routerLink]="['/', Routenames.TtmTickets, ticket.id]">
    <header class="ticket-card-header">
        <h2 class="ticket-user-name">
            @if(isNewTicket()) {
             <i class="fa fa-regular fa-triangle-exclamation new-ticket-icon" matTooltip="Nieuw ticket dat nog niet is bekeken"></i>
            }
            {{ticket.user?.name || 'Onbekende gebruiker'}}</h2>
    </header>

    <div class="ticket-card-actions">
        <div class="status-badge" [ngClass]="'status-' + ticket.status">{{ticket.status | TtmTicketStatus}}</div>

        <button mat-icon-button type="button" [matMenuTriggerFor]="ticketActionsMenu" (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #ticketActionsMenu="matMenu">
            <a mat-menu-item
               routerLink="/{{Routenames.Projects}}/{{ticket.ttm?.project_id}}"
               [queryParams]="{ttm: ticket.ttm_id, drawing: ticket.ttm?.entities[0]?.drawings[0]?.id}">
                <mat-icon>open_in_new</mat-icon>
                <span>Openen TVM</span>
            </a>

            @if (canDeleteTicket) {
                <button mat-menu-item type="button" (click)="deleteTicket.emit(ticket)">
                    <mat-icon>delete</mat-icon>
                    <span>Verwijderen</span>
                </button>
            }
        </mat-menu>
    </div>

    <div class="ticket-card-subheader">
        <span>{{ticket.department | TtmTicketDepartment}}</span>
        <span class="subheader-separator">•</span>
        <span>{{ticket.type | TtmTicketType}}</span>
    </div>

    <div class="ticket-card-body">
        <div class="ticket-field">
            <span class="field-label">Aangemaakt</span>
            <span class="field-value">{{ticket.created_at | date: 'EEE d MMM yyyy HH:mm'}}</span>
        </div>

        <div class="ticket-field">
            <span class="field-label">Toegewezen aan</span>
            <span class="field-value">{{ticket.assignee?.name || 'Niet toegewezen'}}</span>
        </div>

        <div class="ticket-field">
            <span class="field-label">TVM</span>
            <span class="field-value">{{$any(ticket.ttm)?.project?.name}} - {{ticket.ttm_id}}</span>
        </div>

        <div class="ticket-field">
            <span class="field-label">Opmerking</span>
            <p class="field-value comment-clamp">{{ticket.comment || '-'}}</p>
        </div>
    </div>
</article>
